import React, { FC } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../constants/aampeTheme';

interface AudienceFilterChipProps {
    title: string;
    className?: string;
}

const AudienceFilterChip: FC<React.PropsWithChildren<AudienceFilterChipProps>> =
    ({ title, className }) => {
        return <Chip className={className}>{title}</Chip>;
    };

const Chip = styled.div({
    backgroundColor: aampeTheme.colors.gray50,
    borderRadius: aampeTheme.borderRadius.default,
    padding: aampeTheme.spacing(0.5, 1),
    color: aampeTheme.colors.gray800,
});

export default AudienceFilterChip;
